import { Injectable, Injector } from '@angular/core';

import { COMMON_CONTEXT_MENU_EVENT_NAME, ICommonContextMenuOptions } from './common-context-menu.interfaces';
import { CommonContextMenu } from './common-context-menu.service';
import { CommonContextMenuRegistryService } from '@CaseOne/Common/context-menu-registry/common-context-menu-registry.service';

@Injectable({
	providedIn: 'root',
})
export class CommonContextMenuFactory {
	constructor(
		private injector: Injector,
		private commonContextMenuRegistryService: CommonContextMenuRegistryService,
	) {}

	open<DataType = any> (options: ICommonContextMenuOptions<DataType>): CommonContextMenu<DataType> {
		const contextMenu: CommonContextMenu<DataType> = new CommonContextMenu<DataType>(
			options,
			this.injector,
		);

		this.commonContextMenuRegistryService.registerContextMenu({
			id: options.id,
			contextMenuEntity: contextMenu,
			contextMenuHTMLElement: contextMenu.contextMenuContainerElement,
			parentContextMenuEntity: options.parentContextMenu,
			dismissClickIgnore: options.dismissClickIgnore,
			close: () => contextMenu.close(),
			afterClose: contextMenu.onEvent(COMMON_CONTEXT_MENU_EVENT_NAME.AFTER_CLOSE),
		});

		return contextMenu;
	}
}
